import * as TYPES from './mutations-types'

export default {
  [TYPES.SET_MANAGEMENT_CERTIFICATES_LIST] (state, data) {
    state.certificates = data
  },
  [TYPES.SET_MANAGEMENT_ENTREPRENEUR_PROFILES_LIST] (state, data) {
    state.entrepreneurProfiles = data
  },
  [TYPES.SET_MANAGEMENT_PROFILES_LIST] (state, data) {
    state.profiles = data
  },
  [TYPES.SET_SURVEY_LIST] (state, data) {
    state.surveyList = data || []
  },
  [TYPES.SET_PARTNER_LIST] (state, data) {
    state.partnerList = data || []
  }
}
